import React, { useCallback } from "react";
import { StorecastHeaderButton } from "./StorecastHeaderButton";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { useIntl } from "react-intl";

export function StorecastShowFileButton(props: {
  navigation: UserLoggedInNavigatorNavigationProp<"Dashboard">;
  dashboard: {
    id: string;
  };
}) {
  const onPressShowFile = useCallback(() => {
    props.navigation.navigateDeprecated("StorecastShowFile", {
      storecastId: props.dashboard.id,
    });
  }, [props.navigation, props.dashboard.id]);
  const intl = useIntl();
  return (
    <StorecastHeaderButton
      icon="files"
      title={intl.formatMessage({
        defaultMessage: "Show File",
        description: "Storecast Show File Button Title",
      })}
      onPress={onPressShowFile}
    />
  );
}
